import { router, route, unroute } from 'silkrouter';
import 'core-js/features/array/includes';
import { INVALID_ROUTES, ROUTE_NOT_FOUND } from '../constants';
import { hasOwn } from '../utils';

class Router {
    constructor(routes, hashMode) {
        this.subscriptions = [];
        this.hashMode = hashMode;
        if (Array.isArray(routes)) {
            const normalRoutes = [];
            const errorRoutes = [];
            routes.forEach(routeObj => {
                if (hasOwn(routeObj, 'component')) {
                    if (hasOwn(routeObj, 'route')) {
                        const routeString = `${hashMode ? '#' : ''}${routeObj.route}`;
                        if (!normalRoutes.includes(routeString)) {
                            normalRoutes.push(routeString);
                        }
                    } else if (hasOwn(routeObj, 'error')) {
                        const routeString = `${hashMode ? '#' : ''}${routeObj.error}`;
                        if (!normalRoutes.includes(routeString)) {
                            normalRoutes.push(routeString);
                        }
                        if (!errorRoutes.includes(routeString)) {
                            errorRoutes.push(routeString);
                        }
                    }
                } else {
                    throw new TypeError(INVALID_ROUTES);
                }
            });
            this.routeList = routes;
            this.routeFn = (evt) => {
                if ((hashMode && evt.hash) || !hashMode) {
                    if (normalRoutes.includes(evt.route)) {
                        const { data, params, query, route } = evt;
                        this.currentRoute = {
                            route, data, params, query
                        };
                        this.subscriptions.forEach(fn => {
                            fn.apply(this, [this.currentRoute]);
                        });
                    } else if (errorRoutes.length) {
                        router.set(errorRoutes[0], true); // Replace existing route with error route
                    } else {
                        throw new Error(ROUTE_NOT_FOUND);
                    }
                }
            }
            route(this.routeFn);
            if (!window.location.hash && hashMode) {
                router.set('#/', true);
            }
        } else {
            throw new TypeError(INVALID_ROUTES);
        }
    }
    routes() {
        return this.routeList.map(routeObj => ({
            route: `${this.hashMode ? '#' : ''}${routeObj.route}`,
            component: routeObj.component
        }));
    }
    destroy() {
        this.subscriptions.length = 0;
        unroute(this.routeFn);
    }
    navigate() {
        router.set(...arguments);
        return this;
    }
    subscribe(callback) {
        if (typeof callback === 'function' && !this.subscriptions.includes(callback)) {
            this.subscriptions.push(callback);
        }
        return this;
    }
}

function routerFn() {
    return new Router(...arguments);
}

export { Router, routerFn };